import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_PAGE_LIMIT,
  DIAM_TEAM_ID,
  diamQueryKeys,
  getTeamApplicationContextsPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { SelectOption } from './types';

export function useCreateTeamApplicationOptions(enabled: boolean) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  const applicationContextsQuery = useQuery({
    queryKey: diamQueryKeys.teamApplicationContexts(DIAM_TEAM_ID),
    queryFn: async () => {
      const idToken = await getIdToken();
      return getTeamApplicationContextsPage(apiUrl, idToken, DIAM_TEAM_ID, {
        page: 0,
        limit: DIAM_PAGE_LIMIT,
      });
    },
    enabled: isSignedIn && enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const applicationOptions = useMemo<SelectOption[]>(
    () =>
      (applicationContextsQuery.data?.elements ?? []).map(application => ({
        label: application.name,
        value: application.id,
      })),
    [applicationContextsQuery.data],
  );

  return {
    applicationOptions,
    isLoading: applicationContextsQuery.isLoading,
    isError: applicationContextsQuery.isError,
    error: applicationContextsQuery.error,
  };
}
